module.exports = __webpack_public_path__ + "static/media/note3.357815ee.png";